// StatusBadge: project status pill (dot + label).
// Maps status enum → badge--<modifier> + human-readable label.

import type { ProjectStatus } from '@lib/schemas/project';

const STATUS_LABEL: Record<ProjectStatus, readonly [string, string]> = {
  shipped:  ['badge--shipped',  'Shipped'],
  oss:      ['badge--oss',      'Open source'],
  research: ['badge--research', 'Published'],
  wip:      ['badge--wip',      'In progress'],
};

export interface StatusBadgeProps {
  status: ProjectStatus;
  /** Override the default label for the given status. */
  label?: string;
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const [modifier, defaultLabel] = STATUS_LABEL[status];
  return (
    <span className={`badge ${modifier}`}>
      <span className="badge__dot" />
      {label ?? defaultLabel}
    </span>
  );
}
